import { createContext } from 'react';

const AudioContext = createContext({
    volume: 1,  // Background music volume
    setVolume: () => {},
    volumefx: 1,  // Click sound volume
    setVolumefx: () => {}
  });
  
  export default AudioContext;